import { Modal } from 'antd';
import { t } from 'i18next';
import invariant from 'tiny-invariant';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { SingleGraphReferenceContextProvider } from 'business/providers/graph-reference';
import { SteeringPageTemplate } from 'business/steering/components/steering-page-template';
import { SteeringTableFilterData } from 'business/steering/pages/table-page';
import { SteeringChartFilters } from 'business/steering/pages/table-page/components/chart/steering-chart-filters';
import { SteeringGraphContainer } from 'business/steering/pages/table-page/components/chart/steering-graph-container';
import { SteeringChartFiltersProvider } from 'business/steering/providers/steering-chart-filters-provider';
import { FilterData } from 'technical/filter-data';
import { CustomFilterCard } from 'ui/filter-card';
import { SelectedItemsFooter } from 'ui/filter-footer';

export const SteeringChartModal = ({
  visibleModal,
  closeModal,
  filterData,
}: {
  visibleModal: boolean;
  closeModal: () => void;
  filterData: FilterData<SteeringTableFilterData>;
}) => {
  const { currentConstructionSite } = useAppContext();
  invariant(currentConstructionSite, 'No construction site');

  return (
    <Modal
      open={visibleModal}
      onCancel={() => closeModal()}
      style={{ top: 20 }}
      width={750}
      footer={false}
    >
      <SingleGraphReferenceContextProvider>
        <SteeringChartFiltersProvider
          initialFilters={{
            position: 'rear',
            scale: currentConstructionSite.tolerance,
            tolerance: currentConstructionSite.tolerance,
          }}
        >
          <SteeringPageTemplate
            title={t('steering.graph.title')}
            filters={
              <CustomFilterCard
                footer={
                  filterData?.selectedRings ? (
                    <SelectedItemsFooter>
                      {t('steering.filters.selectedRings', {
                        selectedRings: filterData.selectedRings,
                      })}
                    </SelectedItemsFooter>
                  ) : null
                }
              >
                <SteeringChartFilters />
              </CustomFilterCard>
            }
            fullPage={false}
          >
            <SteeringGraphContainer />
          </SteeringPageTemplate>
        </SteeringChartFiltersProvider>
      </SingleGraphReferenceContextProvider>
    </Modal>
  );
};
